import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const socials = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/Digiprintnumerique?_rdc=1&_rdr',
    icon: <Facebook className="w-8 h-8" />,
    className: 'bg-[#1877F2] text-white'
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/accounts/login/?next=%2Fdigiprint_numerique%2F&source=omni_redirect',
    icon: (
      <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] flex items-center justify-center text-white">
        <Instagram className="w-5 h-5" />
      </div>
    ),
    className: 'bg-white text-[#DD2A7B] border border-[#F0E1F6]'
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/digiprint-num%C3%A9rique/posts/?feedView=all&viewAsMember=true',
    icon: <Linkedin className="w-8 h-8" />,
    className: 'bg-[#0A66C2] text-white'
  }
];

const SocialFollow = () => {
  return (
    <section className="social-follow">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <span className="social-follow__eyebrow">Suivez-nous</span>
          <h2 className="social-follow__title">Restons connectés</h2>
          <p className="social-follow__subtitle">
            Découvrez nos dernières actualités, projets et inspirations sur les réseaux sociaux.
          </p>
        </div>
        <div className="social-follow__grid">
          {socials.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-follow__card ${social.className}`}
              aria-label={social.name}
            >
              <span className="social-follow__icon">{social.icon}</span>
              <span className="social-follow__label">{social.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialFollow;
